export default __webpack_public_path__ + "static/media/cook5.cc82f836.png";